import React, { useState } from "react";
import PropTypes from "prop-types";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { css } from "@emotion/react";

/**
 * Overlay
 *
 * @param {Object}  overlay
 * @param {Object}  trigger
 * @param {Boolean} asCardOverlay
 * @param {String}  placement
 * @param {String}  width
 * @param {Object}  delay
 */
const Overlay = ({ overlay, trigger, asCardOverlay, placement, width, delay, ...props }) => {
  const [show, setShow] = useState(false);
  const [isOverOverlay, setIsOverOverlay] = useState(false);
  let timer = null;

  const handleLeave = () => {
    setIsOverOverlay(false);
    setShow(false);
  };

  const overlayProps = asCardOverlay
    ? {
        onMouseEnter: () => {
          clearInterval(timer);
          setIsOverOverlay(true);
          setShow(true);
        },
        onMouseLeave: handleLeave,
        css: css`
          width: ${width};
          box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.1);
          border-radius: 1rem;
          margin-bottom: 2rem;
          z-index: 5;
        `,
      }
    : {};

  const handleToggle = (val) => {
    if (!asCardOverlay) {
      setShow(val);
    } else if (val) {
      setShow(true);
    } else if (!isOverOverlay) {
      setShow(false);
    }
  };

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<div {...overlayProps}>{overlay}</div>}
      onToggle={handleToggle}
      show={show}
      delay={delay}
    >
      {({ ref, ...triggerHandler }) => (
        <span ref={ref} {...triggerHandler} {...props}>
          {trigger}
        </span>
      )}
    </OverlayTrigger>
  );
};

Overlay.propTypes = {
  overlay: PropTypes.node.isRequired,
  trigger: PropTypes.node.isRequired,
  asCardOverlay: PropTypes.bool,
  placement: PropTypes.string,
  width: PropTypes.string,
  delay: PropTypes.object,
};

Overlay.defaultProps = {
  asCardOverlay: false,
  placement: "auto",
  width: "40rem",
  delay: { show: 0, hide: 0 },
};

export default Overlay;
